import { ContextService } from '../../../services/context_service';
import { Font, Image, Page, Text, View } from '@react-pdf/renderer';
import { getStyle } from '../../datenauswertung/generisch/DatanauswertungGenerischStyles';
import * as Moment from 'moment';
import { parsePdfSub2 } from '../../datenauswertung/generisch/helper';
import * as React from 'react';
import { SectionStyle } from '../../../helpers/SectionStyle';

export function getPdfData(
    diagramLink: any, size: any, stand: number, unternehmen: string, contextService: ContextService, style?: any,
    callback?: (pageNumber: number, totalPages: number) => void
): JSX.Element {
    style = { ...style };
    // const logoImg = require('../../../img/logo_mittel2.png');
    const logoImg = require('../../../img/Logo.jpg');
    const logoUnternehmenImg = contextService.get('UNTERNEHMEN_LOGO_URL');
    const imgHeight = 440; // Einheit ist DPI !!!
    const imgWidth = imgHeight / size.height * size.width;
    const sectionId: string = typeof SectionStyle.curPrintSectionId === 'number'
        ? SectionStyle.getCurrentId(true)
        : SectionStyle.getCurrentId();
    const logoSection = sectionId ? require(`../../../img/logo_section_${sectionId}.jpg`) : logoImg;
    const styleTitel: React.CSSProperties = { display: 'flex', flexDirection: 'row', alignItems: 'baseline' };
    Font.register({ family: 'Calibri-Bold', src: require('../../../font/calibri_regular.ttf') });

    return (
        <Page size='A4' orientation='landscape' style={{ padding: 40, paddingTop: 20, paddingBottom: 20, fontSize: '10pt' }} wrap={false}>
            <View style={style.mainWrapper}>
                <View style={style.titleWrapper}>
                    {logoUnternehmenImg &&
                        <Image src={logoUnternehmenImg} style={style.titleImage3} />
                    }
                    <Image src={logoSection} style={style.titleImage2} />
                    <View style={{ ...style.titleFont, ...styleTitel }}>
                        <Text>
                            E-Tool{<>:&nbsp;</>}
                        </Text>
                        <Text style={style.titleFont2}>
                            {parsePdfSub2(unternehmen, style.titleFont2)}
                        </Text>
                    </View>
                    <View style={{ ...style.titleFont3, ...styleTitel }}>
                        <Text style={{ fontFamily: 'Calibri-Bold', lineHeight: 1.05 }}>
                            →&nbsp;
                        </Text>
                        <Text>Individueller Betriebsentwicklungsfahrplan</Text>
                    </View>
                </View>
                <View style={style.diagramm}>
                    <Image src={diagramLink} style={{ height: imgHeight, width: imgWidth }} />
                </View>
                <Text style={{ marginTop: 2, marginLeft: 12 }}>
                    Stand: {stand > 0 ? Moment.unix(stand / 1000).format('DD.MM.YYYY') : ''}
                </Text>
            </View>
            <Text style={getStyle('footer')}>{Moment().format('DD.MM.YYYY')}</Text>
            <View style={getStyle('footerPages')}>
                <Text
                    render={({ pageNumber, totalPages }) => {
                        if (typeof callback === 'function' && totalPages) {
                            callback(pageNumber, totalPages);
                        }

                        if (totalPages > 1) {
                            return `${pageNumber}/${totalPages}`;
                        }
                    }}
                    fixed
                />
            </View>
        </Page>
    );
}
